// If you modify this file, you might want to update also https://github.airbus.corp/gire/2i81-cicd-engine/blob/master/a/config/2i81-dfm-gire-api/prod/upload_matrix.json

// 'AS350_B3', 'EC130_T2', 'EC130_T4'
export const HMI_MINI_WACS_FILES = [
  { name: 'CF',
    types: ['WACS']
  },
  { name: 'S/W',
    types: ['WACS']
  }
]
